<template>
  <div class="main">
    <AllHeader title="项目捐赠"></AllHeader>
    <div class="wrapper">
     
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
export default {
  data() {
    return {
      nav: [
        { title: "论坛", url: "lt" },
        { title: "问题解答", url: "wtyd" }
      ]
    };
  },
  mounted() {
    window.scroll(0, 0);
  },
  methods: {},
  components: {
    AllHeader
  }
};
</script>
<style lang="less" scoped>
.main {
  padding-top: 20px;
  margin-bottom: 100px;
  .wrapper {
    width: 100%;
    margin: 30px auto;
    h3 {
      font-size: 16px;
      color: #000;
      font-weight: 700;
      line-height: 1.5;
      width: 90%;
      margin-left: 30px;
    }
    h4 {
      font-size: 14px;
      color: #000;
      line-height: 1.5;
      margin-bottom: 30px;
      width: 90%;
      margin-left: 30px;
    }
    .line {
      width: 100%;
      height: 1px;
      background-color: #e6e6e6;
      margin-bottom: 30px;
    }
  }
}
</style>